import $ from 'jquery';
import breakpoints from '../helpers/breakpoints';

const $window = $(window);

export default class ShowIcon {
  constructor($c) {
    $c.on('mouseenter mouseleave', '.js-show-icon-trigger', e => ShowIcon.triggerMouseHandler(e));
    ShowIcon.observeSceneIcons();
  }
  static observeSceneIcons() {
    if (ShowIcon.sceneObserver) {
      ShowIcon.sceneObserver.disconnect();
      ShowIcon.sceneObserver = null;
    }

    const scenes = document.querySelectorAll('.js-full-page-scene');
    if (!scenes.length || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const items = entry.target.querySelectorAll('.equalizer__icon.js-show-icon-item');
        if (items.length !== 1) return;
        const visible = entry.isIntersecting && entry.intersectionRatio >= 0.55;
        items[0].classList.toggle('_active', visible);
      });
    }, { threshold: [0, 0.55] });

    scenes.forEach((scene) => {
      if (scene.querySelectorAll('.equalizer__icon.js-show-icon-item').length === 1) {
        observer.observe(scene);
      }
    });
    ShowIcon.sceneObserver = observer;
  }
  static triggerMouseHandler(e) {
    const $trigger = $(e.currentTarget);
    const disabledMobile = $trigger.is('[data-disabled-mobile]');
    const show = e.type === 'mouseenter';
    const windowWidth = $window.width();
    const isWorking = !(disabledMobile && windowWidth <= breakpoints.mobile);

    if (isWorking) {
      ShowIcon.toggleIcon($trigger, show);
    }
  }
  static toggleIcon($trigger, show) {
    const group = $trigger.data('group');
    const groupSelector = `[data-group=${group}]`;
    const target = $trigger.data('target');
    const $triggers = $(`.js-show-icon-trigger${groupSelector}`);
    const $group = $(`.js-show-icon-group${groupSelector}`);
    const $items = $group.find('.js-show-icon-item');
    const $item = $items.filter(`[data-target=${target}]`);

    $triggers.removeClass('_active');
    $items.removeClass('_active');

    if (show) {
      $trigger.addClass('_active');
      $item.addClass('_active');
    }
  }
}
